import { useState } from 'react';
import TaggableInput from '../TaggableInput.jsx';
import { EyeIcon } from '@heroicons/react/24/outline/index.js';
import Preview from './Preview.jsx';

const EmailSettings = ({ settings, setSettings, schema, isMarketingAutomation }) => {
    const emailSchema = schema.filter(s => s.type === 'email');
    const [showPreview, setShowPreview] = useState(false);

    return (
        <div>
            {/*<Select*/}
            {/*    label="To"*/}
            {/*    value={settings?.to || ''}*/}
            {/*    onChange={(value) => setSettings({...settings, to: value})}*/}
            {/*    options={emailOptions}*/}
            {/*/>*/}
            <div className="input-label mt-6">To</div>
            <TaggableInput
                schema={emailSchema}
                initialValue={settings?.to || ''}
                onChange={value => setSettings({ ...settings, to: value })}
                appendAfterInsert=", "
            />
            {isMarketingAutomation && (
                <div className="text-sm text-gray-500 mt-1">
                    This will only be sent to clients who opt-in to receiving emails
                </div>
            )}

            <div className="input-label mt-6">Subject</div>
            <TaggableInput
                schema={schema}
                initialValue={settings?.subject || ''}
                onChange={value => setSettings({ ...settings, subject: value })}
            />

            <div className="input-label mt-6">Body</div>
            <TaggableInput
                schema={schema}
                className="min-h-32"
                initialValue={settings?.body || ''}
                showToolbar={true}
                onChange={value => setSettings({ ...settings, body: value })}
            />

            <div className="input-label mt-6">Reply-To</div>
            <TaggableInput
                schema={emailSchema}
                initialValue={settings?.replyTo || ''}
                onChange={value => setSettings({ ...settings, replyTo: value })}
            />

            <div className="input-label mt-6">Also send a copy to admins</div>
            <TaggableInput
                schema={emailSchema}
                initialValue={settings?.adminEmails || ''}
                onChange={value =>
                    setSettings({ ...settings, adminEmails: value })
                }
                appendAfterInsert=", "
            />

            <div className="input-label mt-6">BCC</div>
            <TaggableInput
                schema={emailSchema}
                initialValue={settings?.bcc || ''}
                onChange={value => setSettings({ ...settings, bcc: value })}
                appendAfterInsert=", "
            />

            {!!settings && (
                <button
                    type="button"
                    className="btn-light-pill flex items-center mt-6"
                    onClick={() => setShowPreview(true)}
                >
                    <EyeIcon className="w-4 h-4 mr-2" />
                    Preview
                </button>
            )}

            <Preview
                settings={settings}
                action="email"
                schema={schema}
                isOpen={showPreview}
                onClose={() => setShowPreview(false)}
            />
        </div>
    );
};

export default EmailSettings;
